import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-process-intelligence',
  templateUrl: './process-intelligence.component.html',
  styleUrls: ['./process-intelligence.component.scss']
})
export class ProcessIntelligenceComponent implements OnInit {

  permissionAsssign: any[] = [];
  folderList: any[] = [];

  constructor(private router: Router) { }

  ngOnInit(): void {
   // this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions"));   

    // this.permissionAsssign =this.permissionAsssign.filter((x) => x.permissionName.toLowerCase() == 'menu process intelligence');

    // if(this.permissionAsssign.length == 0){
    //   this.router.navigate(['unauthorised']);
    //   return;
    // }
  }

}
